import { apiGetInsights } from '../../api';
import * as types from '../mutation-types';

// Models
import Insight from '@/store/models/insight';

// initial state
const state = {
  all: {
    data: [],
  },
};

// mutations
const mutations = {
  [types.RECEIVED_INSIGHTS] (state, insights) {
    state.all.data = insights.data;
  },

  [types.RESET_INSIGHTS] (state) {
    state.all.data = [];
  },
};

const actions = {
  getAllInsights: ({ commit }, args) => {
    apiGetInsights(args)
      .then(({ data }) => {
        commit(types.RECEIVED_INSIGHTS, data);
      })
      .catch((error) => {
        console.log(error);
      })
  },
};

const getters = {
  insights (state) {
    return state.all;
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/store/modules/insights.js